import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserSessionPersistence, indexedDBLocalPersistence } from 'firebase/auth';
import { initializeFirestore, doc, setDoc } from 'firebase/firestore';
import { Capacitor } from '@capacitor/core';

// Credenciais de Produção - Phoenix OS
const firebaseConfig = {
  apiKey: "AIzaSyAgvmNWqbaP3SR0mPn6qORa_Pz1sDdYlGM",
  authDomain: "phoenix-os-39a76.firebaseapp.com",
  projectId: "phoenix-os-39a76",
  storageBucket: "phoenix-os-39a76.firebasestorage.app",
  messagingSenderId: "381095369430",
  appId: "1:381095369430:web:65265339488993e4c30777"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Exporta os serviços para o resto do aplicativo usar
export const auth = getAuth(app);
// E-mails do Firebase Auth (redefinição de senha etc.) e a página do link saem em português.
auth.languageCode = 'pt-BR';
export const db = initializeFirestore(app, { localCache: undefined });

// 🔥 CORRIGIDO — VULNERABILIDADE DE NEGÓCIO (2026-09-29, achada num teste
// real de pagamento): 'browserSessionPersistence' guarda o login no
// sessionStorage, que só devia sumir quando a ABA/APP é fechado de
// propósito. Só que no Android o sistema mata o processo do app sozinho
// pra liberar memória sempre que ele fica em segundo plano tempo demais
// (ex: a pessoa saiu pra pagar no navegador do Asaas e voltou) — e isso
// também apaga o sessionStorage, mesmo a pessoa nunca tendo "fechado" o
// app de propósito. Resultado real: cliente pagou o Entry, voltou do
// pagamento, o Android tinha matado o processo por pouca memória, o app
// reabriu do zero, criou uma sessão anônima NOVA (uid diferente) — e o
// dossiê pago, salvo no uid antigo, ficou inacessível (e o convite de
// conta nem chegou a aparecer).
//
// Dentro do app nativo (Capacitor) o cenário de ameaça é outro: o
// aparelho já tem tela de bloqueio própria, e "processo morto pelo
// Android" é rotina, não decisão da pessoa — ali o login deve sobreviver
// (indexedDBLocalPersistence, que fica em disco, não em memória de
// sessão). Já no navegador comum (site aberto num computador, possivelmente
// compartilhado), mantemos a sessão expirando ao fechar a aba — comportamento
// mais seguro pra esse contexto.
setPersistence(auth, Capacitor.isNativePlatform() ? indexedDBLocalPersistence : browserSessionPersistence).catch((error) => {
  console.error('[PHOENIX] Erro ao configurar persistência de sessão:', error);
});

// ID interno da aplicação
export const appId = 'phoenix-os-v1';

// ===================================================================
// 🔗 GERAÇÃO DO LINK DE PAREAMENTO (celular → computador) — usada
// pelo app (botão "Conectar Painel Desktop") e validada pela Cloud
// Function gerarTokenPareamento (chamada em App.js, na TelaPareamento).
// Fica aqui no firebase.js (não em App.js nem MobileInterface.jsx) pra
// evitar import circular entre os dois arquivos.
// ===================================================================
export async function gerarLinkDashboard(uid) {
  const token = crypto.randomUUID();
  const expiraEm = Date.now() + 5 * 60 * 1000; // 5 minutos
  await setDoc(doc(db, 'linkTokens', token), { uid, expiraEm, usado: false });
  // 🔥 No app nativo (Capacitor) window.location.origin é 'https://localhost' — endereço que só
  // existe dentro do celular, então o QR/link abria no computador como "não encontrado".
  // Lá usamos o endereço público do app web; no navegador (e no dev local) vale o endereço atual.
  const base = Capacitor.isNativePlatform() ? 'https://app.phoenixos.com.br' : window.location.origin;
  return `${base}/parear?token=${token}`;
}